import React, { Component } from 'react';
import RecoveryLogsUi from '../../../presentationals/Admin/Recovery/RecoveryComLogs.component';
import { recoveryLogsApi,getRecoveryCommentsByLoanId } from '../AdminActionCreator.component'


class RecoveryLogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recoveryComLogs: '',
            loaderState:false
        }
    }

    componentWillMount() {
        const { dataForCommunication,allDetail } = this.props
        console.log("dataForCommunication",allDetail)
        this.setState({loaderState:true})
        // recoveryLogsApi(dataForCommunication?.userId,
        //     (callBack) => {
        //         this.setState({ recoveryComLogs: callBack ,loaderState:false})
        //     })
        getRecoveryCommentsByLoanId(allDetail?.loanId,
            (callBack) => {
                this.setState({ recoveryComLogs: callBack?.data ,loaderState:false})
            })
    }

    render() {
        return (
            <div className="full-height  ">
                <RecoveryLogsUi
                    recoveryComLogs={this.state.recoveryComLogs}
                    loaderState={this.state.loaderState}
                />
            </div>
        )
    }

}

export default RecoveryLogs;